export enum MessageSeverity {
	INFO = "INFO",
	SUCCESS = "SUCCESS",
	WARNING = "WARNING",
	DANGER = "DANGER",
	LOADING = "LOADING",
}

export enum MessageSize {
	SM = "SM",
	MD = "MD",
	LG = "LG",
}

export interface UiMessageProps {
	severity: MessageSeverity;
	label: string;
	size?: MessageSize;
}
